import React from 'react'
import { Route, Switch } from 'react-router'
import { getConfig } from './config'
import { ErrorPage } from './Components/ErrorPage/ErrorPage'
import { UnblockSuccessMessage } from './Components/UnblockSuccessMessage/UnblockSuccessMessage'
import Auth0Redirect from './Components/Auth0Redirect/Auth0Redirect'
import { OAuthCallback } from './Components/OAuthCallback'
import { FederatedUserInvitationStatus } from './Components/FederatedUserInvitationStatus/FederatedUserInvitationStatus'
import FederatedLogin from './Components/FederatedLogin/FederatedLogin'

class App extends React.Component {

  render() {

    const queryParams = new URLSearchParams(window.location.search);

    const destination = queryParams.get('destination');
    const token = queryParams.get('token');
    // const connection = queryParams.get('connection');

    const shackletonDemoSignInClientId = 'PNSvFDQzkiyy1A668z5ZsxXGEgRGN88h';

    const auth0Config = {
      domain: 'signin.cj.com',
      clientId: shackletonDemoSignInClientId,
      redirectUri: window.location.origin + '/oauth-callback',
      audience: 'cj-platform'
    };

    const appConfig = getConfig()
    const userServiceRootUrl = appConfig.userServiceUrl
    // const metaLoginConnectionName = "meta-poc"
    const metaLoginConnectionName = "meta"

    return (
      <Switch>
        <Route
          path={'/error'}
          render={(props) => <ErrorPage {...props} />}
        />
        <Route
          path={'/unblocked-account-success'}
          render={(props) => <UnblockSuccessMessage {...props} />}
        />
        <Route
          path={'/passwordless-login'}
          render={(props) => <Auth0Redirect auth0Config={auth0Config} title="Login Redirect" destination={destination} {...props} />}
        />
        <Route
          path={'/meta-sso-login'}
          render={(props) => <FederatedLogin auth0Config={auth0Config} connection={metaLoginConnectionName} destination={destination} {...props} />}
        />
        <Route
          path={'/oauth-callback'}
          render={(props) => <OAuthCallback title="Login Redirect" auth0Config={auth0Config} {...props} />}
        />
        <Route
          path={'/invitation-status'}
          render={(props) =>
            <FederatedUserInvitationStatus
              userServiceRootUrl={userServiceRootUrl}
              token={token}
              {...props}
            />}
        />
      </Switch>
    )
  }
}

export default App
